import React from 'react';
import styled from 'styled-components';
import theme from 'src/shared/theme';
import { Button, PrimaryButton } from '../buttons';

// Le due varianti sfumate non hanno ancora un token: restano qui finché non servono altrove.
const AI_GRADIENT = theme.ai.gradient;
const AI_GRADIENT_HOVER = theme.ai.gradientHover;
const AI_GRADIENT_FADED = 'linear-gradient(135deg, rgba(124, 58, 237, 0.4) 0%, rgba(168, 85, 247, 0.4) 50%, rgba(236, 72, 153, 0.4) 100%)';
const AI_GRADIENT_BG = 'linear-gradient(135deg, rgba(124, 58, 237, 0.15) 0%, rgba(168, 85, 247, 0.15) 50%, rgba(236, 72, 153, 0.15) 100%)';
const AI_COLOR = theme.ai.solid;

// ── Badge ────────────────────────────────────────────────────────────

export const AiBadgeStatusLabel = styled.span<{ $active?: boolean }>`
    display: inline-flex;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    width: fit-content;
    margin-bottom: 16px;
    background: ${(p) => (p.$active ? AI_GRADIENT : AI_GRADIENT_BG)};
    color: ${(p) => (p.$active ? '#fff' : AI_COLOR)};
`;

// ── Primary Button ───────────────────────────────────────────────────

export const AiPrimaryButton = styled(PrimaryButton)`
    background: ${AI_GRADIENT};
    border: none;
    color: #fff;

    &:hover:not([disabled]) {
        background: ${AI_GRADIENT_HOVER};
        color: #fff;
    }

    &[disabled] {
        background: ${AI_GRADIENT_FADED};
        color: rgba(255, 255, 255, 0.7);
        opacity: 1;
    }
`;

// ── Secondary Button ─────────────────────────────────────────────────

export const AiSecondaryButton = styled(Button)`
    background: ${AI_GRADIENT};
    border: none;
    color: #fff;

    &:hover:not([disabled]) {
        background: ${AI_GRADIENT_HOVER};
        color: #fff;
    }

    &[disabled] {
        background: ${AI_GRADIENT_FADED};
        color: rgba(255, 255, 255, 0.7);
        opacity: 1;
    }
`;

// ── Text Button ──────────────────────────────────────────────────────

const AiTextButtonWrapper = styled.span`
    cursor: pointer;
    display: inline-flex;
    align-items: center;

    span {
        background: ${AI_GRADIENT};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-weight: 600;
        font-size: 13px;
    }

    &:hover span {
        text-decoration: underline;
    }
`;

const AiTextButtonDisabled = styled(AiTextButtonWrapper)`
    cursor: not-allowed;
    opacity: 0.45;
    pointer-events: none;
`;

export const AiTextButton: React.FC<{ disabled?: boolean; onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void; children?: React.ReactNode }> = ({
    disabled,
    onClick,
    children
}) => {
    const Wrapper = disabled ? AiTextButtonDisabled : AiTextButtonWrapper;
    return (
        <Wrapper onClick={disabled ? undefined : onClick}>
            <span>{children}</span>
        </Wrapper>
    );
};
